export default "__VITE_ASSET__lq1m01R0__"